import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Button, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useFormikContext } from 'formik';

import { ContentInput } from 'api';
import { Loaders } from 'components';
import { useFollowed } from 'hooks';
import { getPostableGroupsToApprove } from 'features/content/helpers';

import { PostSchema } from '../../validations';
import { usePostContext } from '../../PostContext';

const useStyles = makeStyles(theme => ({
  button: {
    marginLeft: theme.spacing(2),
    minWidth: 100,
  },
}));

const FormButtons: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { state } = usePostContext();
  const { postable } = useFollowed();

  const history = useHistory();
  const { dirty, values, isSubmitting } = useFormikContext<ContentInput>();
  const groupsToApprove = getPostableGroupsToApprove(values, postable.list);

  // Due to validation being dependent on UI state we validate manually with Yup
  const isValid = PostSchema.isValidSync(values, { uiState: state });

  function getSaveText() {
    if (groupsToApprove.length) {
      return t('content:saveAndApprove');
    }

    return values.content_id ? t('common:save') : t('common:post');
  }

  return (
    <Grid item xs container justify="flex-end">
      <Grid item>
        <Button
          className={classes.button}
          variant="outlined"
          size="large"
          onClick={() => history.goBack()}
        >
          {t('common:cancel')}
        </Button>
      </Grid>
      <Grid item>
        <Button
          className={classes.button}
          color="primary"
          variant="contained"
          size="large"
          disabled={!isValid || !dirty}
          type="submit"
        >
          {isSubmitting ? <Loaders.Standard height={26} /> : getSaveText()}
        </Button>
      </Grid>
    </Grid>
  );
};

export default FormButtons;
